import { Component } from 'react';
import { Link } from 'react-router';

import MobileDetect from 'mobile-detect';
const isMobile = !!new MobileDetect(navigator.userAgent).mobile();
import $ from 'jquery';

import Data from '../../data';

class Navigation extends Component {

  controllScrolling() {
    if(isMobile) {
      if($('.nav-list').hasClass('active')) {
        $(window).on('touchmove.noScroll mousewheel', (e) => { e.preventDefault(); });
      } else {
        $(window).off('.noScroll mousewheel');
      }
    }
  }

  distributeNav() {
    let $nav  = $('.nav-list'),
       $items = $nav.find('> li'),
       $dots  = $items.find('.dot'),
       space = 0;

    // Calculate each item's width and its total width
    $items.each((index) => {
      space += $items.eq(index).width();
    });

    space = ($nav.width() - space) / ($items.length);

    // add an extra margin to each item except last one
    $items.filter(':not(:last-child)').css({'margin-right': `${space}px`});
    $items.filter(':first-child').css({'margin-left': `${space / 2}px`});
    $items.filter(':last-child').css({'margin-right': `${space / 2}px`});

    // arrange the dot's space
    $dots.css({'right': `-${space / 2}px`});
  }

  openNav() {
    $('.main-nav__hamburger').on('click', (e) => {
      $(e.currentTarget).toggleClass('active');
      $('.nav-list').toggleClass('active');
      this.controllScrolling();
    });

    $('.nav-list > li').on('click', () => {
      $('.main-nav__hamburger').toggleClass('active');
      $('.nav-list').toggleClass('active');
      this.controllScrolling();
    });
  }

  onResize() {
    // If IE9, then distribute nav
    if($('html').hasClass('ie9')) {
      $(window).on('resize', () => {
        this.distributeNav();
      }).trigger('resize');
    }
  }

  componentDidMount() {
    this.openNav();
    if(!isMobile) {
      this.onResize();
    }
  }

  render() {
    return (
      <nav className="main-nav">
        <span className="main-nav__hamburger">
          <span className="line" />
          <span className="line" />
          <span className="line" />
        </span>
        <ul className="nav-list">
          <li><Link to="/about" activeClassName="active">健やかとは<span className="dot" /></Link></li>
          <li><Link to="/services" activeClassName="active">事業と活動<span className="dot" /></Link></li>
          <li><Link to="/entry" activeClassName="active">ご入会<span className="dot" /></Link></li>
          <li><Link to="/recruit" activeClassName="active">求人<span className="dot" /></Link></li>
          <li><Link to="/news" activeClassName="active">お知らせ<span className="dot" /></Link></li>
          <li><Link to="/links" activeClassName="active">リンク集<span className="dot" /></Link></li>
          <li><a href={`mailto:${Data.contact.email}`}>お問い合わせ</a></li>
        </ul>
      </nav>
    )
  }
}

export default Navigation;



/** WEBPACK FOOTER **
 ** ./src/components/modules/Navigation.js
 **/